function shortenAddress(address: string, start = 6, end = 4) {
  if (!address) return "";
  return `${address.slice(0, start)}.....${address.slice(-end)}`;
}

export default shortenAddress;
